import { Icon } from '@cloudscape-design/components';
import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  stayOpen?: boolean;
  size?: string;
  color?: string;
};

export function Modal({ isOpen, onClose, children, stayOpen, size, color }: ModalProps) {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && !stayOpen) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div
        className={`rounded-lg relative mx-4 px-4 border-gray-900 border-8 ${
          size !== undefined ? size : 'w-auto'
        } ${color ? color : 'bg-gray-900'}`}
      >
        {!stayOpen && (
          <button
            className="absolute top-2 right-2 text-gray-200 hover:text-gray-100 text-xs"
            onClick={onClose}
          >
            <Icon name="close" size="medium" variant="normal" />
          </button>
        )}
        <div className="mt-4 overflow-y-auto max-h-[80vh]">{children}</div>
      </div>
    </div>,
    document.body,
  );
}
